module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" Observar documento\n    "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 5)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "label": "Observacion",
      "maxlength": "500",
      "multi-line": "",
      "counter": 500,
      "rules": _vm.$validate(['required'])
    },
    model: {
      value: (_vm.observacion),
      callback: function($$v) {
        _vm.observacion = $$v
      },
      expression: "observacion"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 5)
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" Cancelar\n      ")], 1), _vm._v(" "), (_vm.$store.state.user.id_rol === 3) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.actualizarEstadoTramiteDoc(_vm.solicitud, 'OBSERVADO_CANCILLERIA_REVISOR', _vm.observacion);
        _vm.$store.commit('closeModal', 5);
        _vm.$store.commit('closeModal', 2);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Observar solicitud\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 6) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.actualizarEstadoTramiteDoc(_vm.solicitud, 'OBSERVADO_ENTIDAD_REVISOR', _vm.observacion);
        _vm.$store.commit('closeModal', 5);
        _vm.$store.commit('closeModal', 2);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Observar solicitud\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.actualizarEstadoTramiteDoc(_vm.solicitud, 'OBSERVADO_CANCILLERIA_FIRMANTE', _vm.observacion);
        _vm.$store.commit('closeModal', 5);
        _vm.$store.commit('closeModal', 3);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Observar solicitud\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 7) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.actualizarEstadoTramiteDoc(_vm.solicitud, 'OBSERVADO_ENTIDAD_FIRMANTE', _vm.observacion);
        _vm.$store.commit('closeModal', 5);
        _vm.$store.commit('closeModal', 3);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Observar solicitud\n    ")], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1668fdba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/tramiteDoc/Observar.vue
// module id = 495
// module chunks = 2